import { gql } from '@apollo/client';

export const UPSERT_ATTENDEES_DATES = gql`
  mutation upsertAttendeesDates($input: upsertAttendeesDatesInput!) {
    attendees: upsertAttendeesDates(input: $input) {
      id
    }
  }
`;
